export function daysBetweenDates(firstDate: Date, secondDate: Date) {

    // Calcula a diferença em milissegundos
    const diffInMs = Math.abs(firstDate.getTime() - secondDate.getTime());

    // Converte a diferença de milissegundos para dias
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays;
}